var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2020-04-21 15:54:08
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-05 11:50:52
 * @Description:
 * @Developer:
 */
import Axios from 'axios';
import EventEmitter from 'eventemitter3';
import cookies from 'browser-cookies';
import jwt from 'jwt-decode';
import { isArray } from 'lodash';
const emitter = new EventEmitter();
const http = Axios.create(Object.assign({
// paramsSerializer: (params:any) => {
//   console.log(params)
//   return qs.stringify(params, {
//     arrayFormat: 'repeat',
//     serializeDate: (date: Date) => moment.tz(date, 'utc').format()
//   })
// }
}, CONFIG.http));
let authorization = cookies.get('Authorization');
http.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    if (authorization) {
        config.headers = Object.assign(Object.assign({}, (config.headers || {})), { Authorization: authorization });
    }
    return config;
}), (error) => error);
http.interceptors.response.use((response) => {
    if (response.headers.authorization) {
        authorization = response.headers.authorization;
        authorization && cookies.set('Authorization', authorization);
    }
    let contenttype = response.headers['content-type'];
    if (contenttype && contenttype.startsWith('application/json')) {
        const rs = response.data;
        if (!rs.success) {
            return Promise.reject(rs.code);
        }
        return Promise.resolve(rs.data);
    }
    return response;
}, (error) => {
    var _a;
    emitter.emit('response-error', error, (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status, error === null || error === void 0 ? void 0 : error.response);
    return Promise.reject(error);
});
function buildUrl(url, config) {
    if (!config) {
        return [url, {}];
    }
    const o = Object.assign(Object.assign({}, config), {
        params: Object.assign({}, config.params),
        data: isArray(config.data) ? config.data : Object.assign({}, config.data)
    });
    if (!o.params)
        return [url, config];
    const list = url.match(/:\w+/g) || [];
    for (let item of list) {
        const value = o.params ? o.params[item.substring(1)] : undefined;
        url = url.replace(item, value !== undefined ? value.toString() : item);
        delete o.params[item.substring(1)];
    }
    return [url, o];
}
export class GenericHttpInstance {
    constructor(instance, uri) {
        this.instance = instance;
        this.uri = uri;
    }
    list(keywords, page, size = 25) {
        return this.instance.get(`${this.uri}/list/${page}?size=${size}&keywords=${keywords}`);
    }
    load(id) {
        return this.instance.get(`${this.uri}/${id}`);
    }
    save(data) {
        return this.instance.post(`${this.uri}`, data);
    }
    update(data) {
        return this.instance.put(`${this.uri}`, data);
    }
    status(status, id) {
        return this.instance.put(`${this.uri}/${status}`, id);
    }
    remove(id) {
        return this.instance.delete(`${this.uri}`);
    }
    request(config) {
        if (!config.url) {
            return Promise.reject();
        }
        let [url, conf] = buildUrl(config.url, config);
        if (!conf) {
            return Promise.reject();
        }
        conf.url = url;
        return this.instance.request(conf);
    }
    get(url, config) {
        return this.instance.get(...buildUrl(`${this.uri || ''}${url}`, config));
    }
    delete(url, config) {
        return this.instance.delete(...buildUrl(url, config));
    }
    head(url, config) {
        return this.instance.head(url, config);
    }
    options(url, config) {
        return this.instance.options(url, config);
    }
    post(url, data, config) {
        const [url2, config2] = buildUrl(url, config);
        return this.instance.post(url2, data, config2);
    }
    put(url, data, config) {
        const [url2, config2] = buildUrl(url, config);
        return this.instance.put(url2, data, config2);
    }
    upload(url, file, data) {
        const form = new FormData();
        data && Object.entries(data).forEach(([key, value]) => {
            form.append(key, value);
        });
        form.append('file', file);
        return this.instance.post(url, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
    patch(url, data, config) {
        return this.instance.patch(url, data, config);
    }
    emit(event, ...args) {
        emitter.emit(event, ...args);
        return this;
    }
    on(event, fn, context) {
        emitter.on(event, fn, context);
        return this;
    }
    off(event, fn, context, once) {
        emitter.off(event, fn, context, once);
        return this;
    }
    get jwt() {
        return authorization ? jwt(authorization) : null;
    }
    set token(token) {
        authorization = token;
    }
    get token() {
        return authorization;
    }
}
export default function (uri) {
    return new GenericHttpInstance(http, uri);
}
